import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const SendHTMLDoc = () => {
  const config = getSendConfig('htmlDoc');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default SendHTMLDoc;
